import React from 'react';
import { Box } from '../../../../../../../../../../CommonComponents/OPL/Box/Box';
import { Avatar } from '../Avatar/Avatar';
import { Text } from '../../../../../../../../../../CommonComponents/OPL/Text/Text';
import { VARIANT_MAP } from '../../FlowChart.meta';
import { Lozenge } from '../../../../../../../../../../CommonComponents/OPL/Lozenge/Lozenge';
import { Separator } from '../../../../../../../../../../CommonComponents/OPL/Separator/Separator';
import { formatCurrency } from '../../../../../../../../../../CommonUtils/formatNumber';
import { Card, GroupLine, HorizontalLine, VerticalLine } from './Nodes.styles';
import { Item, ItemType } from '../../../../api/useEstatePlanningFlowQuery';
import { AdditionalInfo } from '../../../AdditionalInfo/AdditionalInfo';

interface Props {
  items: Item[];
  isFirst?: boolean;
  isLast?: boolean;
}

export const Nodes = ({ items, isFirst, isLast }: Props) => {
  return (
    <HorizontalLine isFirst={isFirst} items={items.length}>
      <GroupLine isVisible={!isFirst && items.length > 1}>
        {items.map((item, itemIndex) => {
          return (
            <VerticalLine key={itemIndex} firstConnectorLine={isFirst} lastConnectorLine={isLast}>
              <Card
                py="12"
                px="16"
                color={VARIANT_MAP[item.type]}
                display="flex"
                flexDirection="column"
              >
                <Box display="flex" css="grid-gap: 8px" alignItems="center" justifyContent="center">
                  <Avatar type={item.type} nameList={item.nameList} />
                </Box>

                <Box
                  minHeight="30px"
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="space-between"
                  gridGap="8"
                  mt="8"
                >
                  {item.label && (
                    <Text
                      fontWeight={600}
                      color="neutral.500"
                      textTransform="uppercase"
                      textAlign="center"
                      fontSize="small"
                    >
                      {item.label}
                    </Text>
                  )}

                  <Box display="flex" alignItems="center" justifyContent="center">
                    <Text fontSize="h6" fontWeight={600} textAlign="center">
                      {(item.type === ItemType.Principal || item.type === ItemType.Spouse) &&
                        item.nameList &&
                        item.nameList.length > 0 &&
                        item.nameList[0]}

                      {item.type === ItemType.TaxesAndFees && 'State, Federal Taxes and Fees'}
                      {item.type === ItemType.Beneficiaries && 'Beneficiaries'}
                      {item.type === ItemType.CharityBeneficiaries && 'Charitable Beneficiaries'}

                      {item.additionalInfo && (
                        <AdditionalInfo additionalInfo={item.additionalInfo} />
                      )}
                    </Text>
                  </Box>
                </Box>

                <Box display="flex" flexDirection="column" flex={1} justifyContent="flex-end">
                  {(item.type === ItemType.Spouse || item.type === ItemType.Beneficiaries) && (
                    <Box display="flex" alignItems="center" justifyContent="center">
                      <Lozenge>
                        {item.type === ItemType.Spouse
                          ? 'Spousal Beneficiary'
                          : 'Non-spousal Beneficiaries  '}
                      </Lozenge>
                    </Box>
                  )}

                  <Separator my="8" />

                  <Text variant="smallCaps" textAlign="center">
                    Total Value
                  </Text>

                  <Text variant="tabular" fontSize="h4" fontWeight={500} textAlign="center">
                    {formatCurrency(item.value)}
                  </Text>
                </Box>
              </Card>
            </VerticalLine>
          );
        })}
      </GroupLine>
    </HorizontalLine>
  );
};
